import { render, staticRenderFns } from "./MppFile.vue?vue&type=template&id=656a3414&scoped=true"
import script from "./MppFile.vue?vue&type=script&lang=js"
export * from "./MppFile.vue?vue&type=script&lang=js"
import style0 from "./MppFile.vue?vue&type=style&index=0&id=656a3414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a3414",
  null
  
)

export default component.exports